import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable camelcase */
import React, { useRef, useState, useEffect } from 'react';
import { Row, Col, Table, Dropdown, useUrlParams, useIsMounted, useUser, showSuccess } from 'components';
import { showApiError } from 'utils';
import { getReportedPayments, confirmReport } from 'services';
import { tableWrap } from 'styles';
import { reportedPaymentsColumns } from './config';
import ConfirmReportModal from './ConfirmReportModal';
import { tableHeaderContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var ReportedPayments = function ReportedPayments() {
  var _offices$, _userInfo$currentOffi;

  var _useUser = useUser(),
      roleAdditionalData = _useUser.roleAdditionalData,
      userInfo = _useUser.userInfo;

  var _useUrlParams = useUrlParams(),
      urlQueryParams = _useUrlParams.urlQueryParams;

  var tableRef = useRef();
  var modalRef = useRef();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedReport = _useState2[0],
      setSelectedReport = _useState2[1];

  var queryParams = useRef(urlQueryParams);
  var isMounted = useIsMounted();
  var offices = (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.offices) || [];
  var employees = (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.employees) || [];

  var _useState3 = useState(urlQueryParams.office || (offices.length === 1 ? (_offices$ = offices[0]) === null || _offices$ === void 0 ? void 0 : _offices$.id : null)),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedOffice = _useState4[0],
      setSelectedOffice = _useState4[1];

  var _useState5 = useState(urlQueryParams.employee || null),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedEmployee = _useState6[0],
      setSelectedEmployee = _useState6[1];

  var userOfficeId = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$currentOffi = userInfo.currentOffice) === null || _userInfo$currentOffi === void 0 ? void 0 : _userInfo$currentOffi.id;
  var initialFetchDone = useRef(false);
  useEffect(function () {
    var _offices$2;

    if (!selectedOffice && offices.length === 1) setSelectedOffice((_offices$2 = offices[0]) === null || _offices$2 === void 0 ? void 0 : _offices$2.id);
  }, [offices]);
  useEffect(function () {
    if (!initialFetchDone.current) {
      initialFetchDone.current = true;
      fetchData();
    } else if (isMounted.current) fetchData();
  }, [selectedOffice, selectedEmployee]);

  var fetchData = function fetchData() {
    var _tableRef$current;

    var params = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      office: selectedOffice,
      employee: selectedEmployee
    });

    (_tableRef$current = tableRef.current) === null || _tableRef$current === void 0 ? void 0 : _tableRef$current.getData(params);
  };

  var fetchReportedPayments = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tableOptions) {
      var _yield$getReportedPay, _yield$getReportedPay2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getReportedPayments(tableOptions);

            case 2:
              _yield$getReportedPay = _context.sent;
              _yield$getReportedPay2 = _slicedToArray(_yield$getReportedPay, 2);
              res = _yield$getReportedPay2[0];
              err = _yield$getReportedPay2[1];

              if (!err) {
                _context.next = 9;
                break;
              }

              showApiError(err);
              return _context.abrupt("return", [null, err]);

            case 9:
              return _context.abrupt("return", [res, null]);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchReportedPayments(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleOfficeChange = function handleOfficeChange(value) {
    setSelectedOffice(value);
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      office: value
    });
  };

  var handleEmployeeChange = function handleEmployeeChange(value) {
    setSelectedEmployee(value);
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      employee: value
    });
  };

  var handleConfirmClick = function handleConfirmClick(report) {
    var _modalRef$current;

    setSelectedReport(report);
    (_modalRef$current = modalRef.current) === null || _modalRef$current === void 0 ? void 0 : _modalRef$current.open();
  };

  var handleConfirmReport = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _modalRef$current2;

      var _yield$confirmReport, _yield$confirmReport2, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (selectedReport) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.next = 4;
              return confirmReport(selectedReport.id);

            case 4:
              _yield$confirmReport = _context2.sent;
              _yield$confirmReport2 = _slicedToArray(_yield$confirmReport, 2);
              err = _yield$confirmReport2[1];

              if (!err) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 9:
              showSuccess('Отчетът е потвърден успешно!');
              (_modalRef$current2 = modalRef.current) === null || _modalRef$current2 === void 0 ? void 0 : _modalRef$current2.close();
              setSelectedReport(null);
              fetchData();

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleConfirmReport() {
      return _ref2.apply(this, arguments);
    };
  }();

  var filterBar = function filterBar() {
    return ___EmotionJSX("section", {
      css: tableHeaderContainer
    }, ___EmotionJSX(Row, {
      horizontalGap: 16,
      verticalGap: 8
    }, offices.length > 0 && ___EmotionJSX(Col, {
      sm: 12,
      md: 4
    }, ___EmotionJSX(Dropdown, {
      small: true,
      withSearch: true,
      placeholder: "\u041E\u0444\u0438\u0441",
      displayKey: "name",
      uniqueKey: "id",
      value: selectedOffice,
      options: offices,
      onChange: handleOfficeChange,
      mapValue: function mapValue(val) {
        return val === null || val === void 0 ? void 0 : val.id;
      }
    })), employees.length > 0 && ___EmotionJSX(Col, {
      sm: 12,
      md: 4
    }, ___EmotionJSX(Dropdown, {
      small: true,
      withSearch: true,
      placeholder: "\u0421\u043B\u0443\u0436\u0438\u0442\u0435\u043B",
      displayKey: "name",
      uniqueKey: "id",
      value: selectedEmployee,
      options: employees,
      onChange: handleEmployeeChange,
      mapValue: function mapValue(val) {
        return val === null || val === void 0 ? void 0 : val.id;
      }
    }))));
  };

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    css: tableWrap
  }, ___EmotionJSX(Table, {
    hasPagination: true,
    ref: tableRef,
    getDataMethod: fetchReportedPayments,
    columns: reportedPaymentsColumns(userOfficeId, handleConfirmClick),
    emptyMessage: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u0437\u0430\u043F\u0438\u0441\u0438",
    filterBar: filterBar,
    margin: "0 2em",
    pageSize: 20
  })), ___EmotionJSX(ConfirmReportModal, {
    modalRef: modalRef,
    report: selectedReport,
    onConfirm: handleConfirmReport,
    onClose: function onClose() {
      return setSelectedReport(null);
    }
  }));
};

export default ReportedPayments;